export type ReceiptSearchConditionValue =
  (typeof ReceiptSearchConditionValue)[keyof typeof ReceiptSearchConditionValue];
export const ReceiptSearchConditionValue = {
  /** 出発日 */
  DEPARTURE_DATE: 0,
  /** 購入日 */
  PURCHASE_DATE: 1,
  /** 航空券番号 */
  ETICKET_NUMBER: 2,
  /** EMDリスト表示 */
  EMD_LIST: 3,
  /** EMD番号 */
  EMD_NUMBER: 4,
} as const;
